module.exports = __webpack_public_path__ + "static/media/img-1.6db7913d.jpg";